import backofficeService from "../../api/backoffice"

export default {
  /**
   *  Get token from server
   * @param {} id
   * @param {*} pin
   * @param {*} locationCode
   * @param {*} deviceCode
   * @param {*} deviceName
   */
  authenticate(params) {
    return backofficeService.Api().post("auth/token", {
      email: params.email,
      password: params.password,
      ...(Array.isArray(params.mfaAuthorizations) && params.mfaAuthorizations.length
        ? { mfaAuthorizations: params.mfaAuthorizations }
        : {}),
      ...(params.trustDevice === true ? { trustDevice: true } : {}),
    }, {
      withCredentials: true,
    })
      .then((response) => {
        localStorage.setItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`, response.data.data.token)
        return response.data
      })
      .catch((error) => { throw error })
  },
  sendMfaCode(data) {
    return backofficeService.ApiWithoutInterceptor()
      .post("auth/mfa/send", data)
      .then(response => response.data)
      .catch(error => { throw error.response || error })
  },
  verifyMfa(data) {
    return backofficeService.ApiWithoutInterceptor()
      .post("auth/mfa/verify", data)
      .then(response => response.data)
      .catch(error => { throw error.response || error })
  },
  /**
   *  Get token from server
   * @param {} id
   * @param {*} pin
   * @param {*} locationCode
   * @param {*} deviceCode
   * @param {*} deviceName
   */
  verify(params) {
    return backofficeService.ApiWithoutInterceptor().post("auth/token", {
      email: params.email,
      password: params.password,
    })
      .then((response) => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Remove the location code store if there exist one/
   */
  resetOrganization() {
    return localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`)
  },
  /**
   * Send forgot password email
   * @param {*} params Query Options
   */
  forgetPassword(data) {
    return backofficeService.Api().post("auth/forget", data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Reset Password
   * @param {*} params Query Options
   */
  resetPassword(data) {
    return backofficeService.Api().post("auth/reset", data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
}
